var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load-shape"},[_c('FormTab'),_c('div',{staticClass:"brute-hide"},[_vm._v(" shape_url : "+_vm._s(_vm.shape_url)),_c('br'),_vm._v(" currentShape : "+_vm._s(_vm.currentShape)),_c('br')])],1)}
var staticRenderFns = []

export { render, staticRenderFns }